import { lazyRouteComponent } from "@tanstack/react-router";
import type { At } from "../../router";

export const CrmRoutes = (at: At) => [
  at("/crm", lazyRouteComponent(() => import("./Pipeline"), "PipelineBoard")),
  at("/crm/deals/$dealId", lazyRouteComponent(() => import("./Pipeline"), "PipelineBoard")),
  at("/crm/list", lazyRouteComponent(() => import("./Pipeline"), "DealList")),
  at("/crm/forecast", lazyRouteComponent(() => import("./Pipeline"), "Forecast")),
  at("/crm/reports", lazyRouteComponent(() => import("./Reports"), "CrmReports")),
  at("/crm/stages", lazyRouteComponent(() => import("./Pipeline"), "Stages")),
  at("/crm/activities", lazyRouteComponent(() => import("./Records"), "ActivitiesPage")),
  at("/crm/companies", lazyRouteComponent(() => import("./Records"), "CompaniesPage")),
  at("/crm/companies/$id", lazyRouteComponent(() => import("./Records"), "CompanyDetail")),
  at("/crm/contacts", lazyRouteComponent(() => import("./Records"), "ContactsPage")),
  at("/crm/contacts/$id", lazyRouteComponent(() => import("./Records"), "ContactDetail")),
];
